export class AdvancedFormMetadataConstant {
  public static ADVANCED_FORM_PROPERTY = 'advanced-forms.property';
  public static ADVANCED_FORM_CONTROL = 'advanced-forms.advanced-form-control';
  public static ADVANCED_FORM_ARRAY = 'advanced-forms.advanced-form-array';
  public static ADVANCED_FORM_GROUP = 'advanced-forms.advanced-form-group';
  public static TRANSLATION_BASE_KEY = 'advanced-forms.translation-base-key';
}